import { Button } from 'components/atoms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiArrowRight, PiCaretLeft, PiX } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { IChildrenProp } from 'types/components/components.interface';
import './StepsTab.scss';

export interface IStepsTabProps<Form extends {}> extends IChildrenProp {
  backName?: string;
  onBack?: () => void;
  nextName?: string;
  onNext?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  nextDisabled?: (form: Form) => boolean;
  nextIcon?: ReactNode;
}

const StepsTab = <Form extends {}>({
  backName,
  onBack,
  onNext,
  nextName,
  children,
  isFirst,
  isLast,
  nextDisabled,
  nextIcon,
}: IStepsTabProps<Form>) => {
  const { t } = useTranslation();
  const { values, status }: IFormikContextType<Form> = useFormikContext<Form>();

  const triggerSubmitButton = () => {
    const button = document.getElementById('form-submit-step-tab');
    if (button) {
      button.click();
    } else {
      console.warn('Form submit button not found!');
    }
  };

  return (
    <div className="steps-tab">
      {children}
      {!status?.displayMode && (
        <div className="steps-tab-footer">
          {!isFirst && (
            <Button variant={BUTTON_VARIANT.background} onClick={onBack} onlyIcon>
              <Button.Icon icon={isFirst ? <PiX /> : <PiCaretLeft />} />
              {/* <Button.Text
                text={isFirst ? t('button.cancel') : backName ? t(`tabs.${backName}`) : ''}
              /> */}
            </Button>
          )}
          <Button
            fullWidth
            variant={BUTTON_VARIANT.submit}
            onClick={isLast ? triggerSubmitButton : onNext}
            disabled={nextDisabled ? nextDisabled(values) : false}
            isLoading={status?.isLoading}
          >
            <Button.Text text={nextName ? t(`tabs.${nextName}`) : ''} />
            <Button.Icon icon={nextIcon ?? <PiArrowRight />} />
          </Button>
        </div>
      )}
    </div>
  );
};

export default StepsTab;
